import React from 'react';

import logo from '../media/images/logo.svg';
import '../media/App.css';

export default class Header extends React.Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <a href={'/'}><img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Vendor Help Desk</h1></a>
        </header>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js